export enum PersonalDetails {
  ORGANIZATION_NAME = "organizationName",
  ORGANIZATION_ROLE = "organizationRole",
  SECTOR = "sector",
  WORK_LOCATION = "workLocation",
  BIO = "bio",
  CHAT_OPTIONS = "chatOptions",
}
